export default "__VITE_ASSET__5opBgQ$5__"